import KeplerSdk from './../../keplerSdk.js'

const state = {
    licenseTypes: [],
    licenseTypesLastFetch: null
}

const mutations = {
    SET_LICENSE_TYPES_LIST (state, message) {
        state.licenseTypes = message
    },
    SET_LICENSE_TYPES_LAST_FETCH (state, message) {
        state.licenseTypesLastFetch = message
    },
}

const actions = {
    fetchLicenseTypes: ({commit}, payload) => {
        if (state.licenseTypesLastFetch == null) {
            KeplerSdk.getDriverLicense(function (data) {
                commit('SET_LICENSE_TYPES_LAST_FETCH', Math.floor(Date.now() / 1000))
                commit('SET_LICENSE_TYPES_LIST', data)
            }, function (data) {

            })
        }
    },
}

export default {
    state, mutations, actions
}


// WEBPACK FOOTER //
// ./src/store/frontoffice/licenseTypesStore.js